import { SAMPLE_STATUS_DICT } from "./../../../shared/constants/sample-status";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class SampleStatusMixin extends Vue {
  public get sampleStatusDict() {
    return SAMPLE_STATUS_DICT;
  }
}
